/* You can add your custom scripts here */

/* Slideshow 自动播放 - 只针对首页幻灯片 */
function startSlideshow() {
  var nextBtn = document.querySelector('.section-slideshow .splide__arrow--next');
  if (!nextBtn) { setTimeout(startSlideshow, 500); return; }
  setInterval(function() {
    nextBtn.click();
  }, 5000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startSlideshow);
} else {
  startSlideshow();
}
/* You can add your custom scripts here */

/* Slideshow + Announcement bar 自动播放 */
function autoClickNext(selector, interval) {
  function tryClick() {
    var btn = document.querySelector(selector);
    if (!btn) { setTimeout(tryClick, 500); return; }
    setInterval(function() { btn.click(); }, interval);
  }
  tryClick();
}

setTimeout(function() {
  // 首页幻灯片 每5秒
  autoClickNext('.section-slideshow .splide__arrow--next', 5000);
  // 公告栏 每8秒
  autoClickNext('#splide02 .splide__arrow--next', 8000);
}, 2000);



